/**
 * <collect-add> — "add this part to the list I am fetching from my dealer".
 *
 * Step 2 of the collect flow, on the product page. Stays hidden until the availability panel
 * beside it has confirmed that dealers carry the part at all: a button to collect something
 * no dealer stocks is an invitation to a wasted trip.
 *
 * Interface: data-sku, data-title, data-url, data-add, data-added, and a child
 * [data-collect-add] that receives the label.
 */
if (!customElements.get('collect-add')) {
  customElements.define(
    'collect-add',
    class CollectAdd extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-collect-add]');
        this.sku = this.dataset.sku;
        if (!this.button || !this.sku || !window.ValerydDealer) return;

        this.onClick = () => {
          window.ValerydDealer.add({
            sku: this.sku,
            title: this.dataset.title || this.sku,
            url: this.dataset.url || '',
            quantity: 1,
          });
        };
        this.onChange = () => this.render();
        // The availability panel is what knows whether any dealer carries this part; it reveals
        // its own controls when the proxy answers, and this follows the same signal.
        this.onStock = () => {
          this.hidden = false;
          this.render();
        };
        this.button.addEventListener('click', this.onClick);
        document.addEventListener('dealer:changed', this.onChange);

        const panel = document.querySelector('store-availability');
        if (panel) {
          this.watcher = new MutationObserver(() => {
            const trigger = panel.querySelector('[data-dealer-trigger]');
            if (trigger && !trigger.hidden) this.onStock();
          });
          this.watcher.observe(panel, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
        }
        this.render();
      }

      disconnectedCallback() {
        if (this.button) this.button.removeEventListener('click', this.onClick);
        document.removeEventListener('dealer:changed', this.onChange);
        if (this.watcher) this.watcher.disconnect();
      }

      render() {
        const on = window.ValerydDealer.has(this.sku);
        this.button.textContent = on ? this.dataset.added || '' : this.dataset.add || '';
        this.button.disabled = on;
      }
    }
  );
}
